import React from 'react';
import ActionsBlock from './components/notifications_datatable/ActionsBlock';
import * as DatesUtils from '../../utils/dates';
import { Languages, AuthRoles } from '../../config';

const CONFIGURATION = {};

export default CONFIGURATION;

// export const TableColumns = [
//   {
//     label: '#',
//     id: 'notification_id',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },
//   {
//     label: 'VAT Number',
//     id: 'vat_num',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },

//   {
//     label: 'Type',
//     id: 'notification_type',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },

//   {
//     label: 'Title',
//     id: 'notification_title',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },

//   {
//     label: 'Message',
//     id: 'notification_message',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },
//   {
//     label: 'Seen',
//     id: 'is_read',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue ? 'Yes' : 'No'}</React.Fragment>
//     ),
//     inData: true,
//   },
//   // {
//   //   label: 'Actions',
//   //   align: 'center',
//   //   id: 'action1',
//   //   render: (
//   //     rowIndex: number,
//   //     cellValue: any,
//   //     columnIndex: number,
//   //     data: any
//   //   ) => (
//   //     <ActionsBlock
//   //       rowIndex={rowIndex}
//   //       data={data}
//   //       dataid={data[rowIndex].notification_id}
//   //     />
//   //   ),
//   //   inData: false,
//   // },
// ];

// interface ITableDefaultFetchValues {
//   TABLE_DEFAULT_PAGE: number;
//   TABLE_DEFAULT_PAGE_SIZE: number;
//   TABLE_DEFAULT_ORDER: 'desc' | 'asc';
//   TABLE_DEFAULT_SORT_KEY: string;
// }

// export const TableDefaultFetchValues: ITableDefaultFetchValues = {
//   TABLE_DEFAULT_PAGE: 0,
//   TABLE_DEFAULT_PAGE_SIZE: 10,
//   TABLE_DEFAULT_ORDER: 'desc',
//   TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
// };

export const Translations = {
  page_title: {
    [Languages.Greek]: 'Notifications',
    [Languages.English]: 'Notifications',
  },
  reminders_title: {
    [Languages.Greek]: 'Reminders',
    [Languages.English]: 'Reminders',
  },
  reminders_description: {
    [Languages.Greek]:
      'Below is a list of the Reminders you received according to your OSS Activity. Reminders affect the Business Process of your OSS Registration, Vat Returns and Payments, and they need to be resolved directly by you, as soon as possible. For questions on how to proceed with any reminders that you have received, you can contact us.',
    [Languages.English]:
      'Below is a list of the Reminders you received according to your OSS Activity. Reminders affect the Business Process of your OSS Registration, Vat Returns and Payments, and they need to be resolved directly by you, as soon as possible. For questions on how to proceed with any reminders that you have received, you can contact us.',
  },
  notifications_title: {
    [Languages.Greek]: 'Notifications',
    [Languages.English]: 'Notifications',
  },
  notifications_description: {
    [Languages.Greek]:
      'Below is a list of your OSS Notifications that were generated from the Application according to your OSS Activity. These Notifications have been sent to your Account email as well.',
    [Languages.English]:
      'Below is a list of your OSS Notifications that were generated from the Application according to your OSS Activity. These Notifications have been sent to your Account email as well.',
  },
  NotificationModalViewTitle: {
    [Languages.Greek]: 'Προεπισκόπηση',
    [Languages.English]: 'View',
  },
  go_to_dashboard: {
    [Languages.Greek]: 'Go to dasbhoard',
    [Languages.English]: 'Go to dasbhoard',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
  vat_number_search_control: {
    [Languages.Greek]: 'VAT Number',
    [Languages.English]: 'VAT Number',
  },
  period_search_control: {
    [Languages.Greek]: 'Period',
    [Languages.English]: 'Period',
  },
  reminded_date_from: {
    [Languages.Greek]: 'Reminded Date From',
    [Languages.English]: 'Reminded Date From',
  },
  reminded_date_to: {
    [Languages.Greek]: 'Reminded Date To',
    [Languages.English]: 'Reminded Date To',
  },
  notification_type_search_control: {
    [Languages.Greek]: 'Type',
    [Languages.English]: 'Type',
  },
  notification_date_from: {
    [Languages.Greek]: 'Notification Date From',
    [Languages.English]: 'Notification Date From',
  },
  notification_date_to: {
    [Languages.Greek]: 'Notification Date To',
    [Languages.English]: 'Notification Date To',
  },
};
